/**
 * Environment Configuration
 *
 * Centralised access to environment variables and app configuration.
 * Values are defined in .env.development / .env.production.
 *
 * Usage:
 *   import { ENV } from '@/config/env'
 *   const url = ENV.API_BASE_URL
 */

export const ENV = {
  // True when running `vite` dev server OR a --mode development build.
  // Mirrors React Native's __DEV__ — use to gate dev-only behaviour.
  IS_DEV: import.meta.env.MODE === 'development',
  IS_PROD: import.meta.env.MODE === 'production',

  // Enables verbose debug-level logs. Set VITE_DEBUG=true in .env.development.
  DEBUG: import.meta.env.VITE_DEBUG === 'true',

  API_BASE_URL:
    (import.meta.env.VITE_API_BASE_URL as string) || 'http://localhost:3001',
  APP_STORE_URL: (import.meta.env.VITE_APP_STORE_URL as string) || '',
  PLAY_STORE_URL: (import.meta.env.VITE_PLAY_STORE_URL as string) || '',
} as const

/** Throw (dev) or warn (prod) on missing required vars. Call once in main.tsx. */
export function validateEnv(): void {
  const required: Record<string, string> = {
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    VITE_APP_STORE_URL: import.meta.env.VITE_APP_STORE_URL,
    VITE_PLAY_STORE_URL: import.meta.env.VITE_PLAY_STORE_URL,
  }

  const missing = Object.entries(required)
    .filter(([, v]) => !v)
    .map(([k]) => k)

  if (missing.length > 0) {
    const msg = `Missing required environment variables: ${missing.join(', ')}`
    if (ENV.IS_DEV) throw new Error(msg)
    else console.error('❌ Environment validation failed:', msg)
  }
}

/** Log current config. */
export function logEnv(): void {
  console.log('🔧 Environment:')
  console.log('  Mode:         ', ENV.IS_DEV ? 'development' : 'production')
  console.log('  API Base URL: ', ENV.API_BASE_URL)
  console.log('  Debug:        ', ENV.DEBUG)
}
